import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { Box, Tab, Typography } from '@mui/material';

import Header from '~/components/organisms/header/Header';
import { COLORS } from '~/styles/colors';
import { isMobileResolution } from '~/utils/common';

import { ExampleApi } from './components/ExampleApi';
import { ColorShapeTable, FrameTable, TableMainParams } from './components/TableMainParams';

const jsonObject = {
  apikey: 'YOUR_API_KEY',
  data: 'https://qr-gen.com',
  qrtype: 'static',
  title: 'NAME OF YOUR QR CODE',
  transparent: 'off',
  backcolor: '#038895',
  frontcolor: '#ffffff',
  marker_out_color: '#669df4',
  marker_in_color: '#669df4',
  pattern: 'oriental',
  marker: 'flower',
  marker_in: 'circle',
  optionlogo: 'IMAGE_IN_BASE64',
};

export default function PApi() {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(1);

  const handleTabItemClick = (event, newValue) => {
    setCurrentTab(newValue);
  };
  return (
    <Box display="flex" flexDirection="column" sx={{ flex: 1, p: 3, mt: isMobileResolution ? 5 : 0 }}>
      {isMobileResolution ? null : <Header />}

      <Typography fontSize={34} color="black">
        {t('api:header')}
      </Typography>
      <Typography fontSize={16} fontWeight={'400'} color={COLORS.black06}>
        {t('api:description')}
      </Typography>
      <TabContext value={currentTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
          <TabList onChange={handleTabItemClick}>
            {[1, 2, 3].map((item) => {
              return <Tab key={item} label={t(`api:tabs:item_${item}`)} value={item} />;
            })}
          </TabList>
        </Box>
      </TabContext>
      <ExampleApi title={t('api:titleDesign')} params={jsonObject} />

      <ExampleApi title={t('api:titleColor')} params={jsonObject} />

      <TableMainParams title={t('api:table:main')} />
      <ColorShapeTable title={t('api:table:colorShape')} />
      <FrameTable title={t('api:table:frame')} />
    </Box>
  );
}
